import React from 'react';
import LeafletMap from './LeafletMap';

interface Props {
  address: string;
  title?: string;
  heightClass?: string;
}

/**
 * Backwards-compatible wrapper used by Clients, Jobs and Leads. The old
 * Google Maps implementation required a browser key that the project's
 * JavaScript API rejects; Leaflet/OSM needs no key and keeps the address
 * preview usable.
 */
const MapComponent: React.FC<Props> = ({ address, title, heightClass = 'h-64' }) => (
  <div>
    {title && <p className="text-sm font-black text-bark mb-2">{title}</p>}
    <LeafletMap address={address} heightClass={heightClass} />
  </div>
);

export default MapComponent;
